import { LoaderCircle } from 'lucide-react';

export default function Spinner({ size }: { size?: number }) {
    return (
        <LoaderCircle
            className={`h-${size ?? 12} w-${size ?? 12} animate-spin`}
        />
    );
}
